import HeaderWithLogo from "../components/HeaderWithLogo";
import styled from "styled-components";
import email_verification from "../assets/email_verification.svg";
import theme from "../theme/theme";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Wrapper = styled.div`
  height: calc(100vh - HeaderWithLogo);
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${theme.colors.bg};

  @media (max-width: 480px) {
    padding: 20px;
  }

  & div {
    background-color: #fff;
    margin-top: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 40px 80px;
    border-radius: 8px;
    & img {
      height: 145px;
    }

    & h2 {
      font-size: 24px;
      font-weight: 400;
      text-align: center;
    }

    & button {
      width: 170px;
      height: 50px;
      font-size: 20px;
      font-weight: bold;
      color: #fff;
      background-color: #33ccff;
      border: none;
      border-radius: 8px;
    }
  }
  & p {
    margin-top: 30px;
    font-size: 12px;
  }
`;

const NewEmailVerification = () => {
  const history = useHistory();
  setTimeout(() => {
    history.push("/login");
  }, 10000);

  return (
    <>
      <HeaderWithLogo />
      <Wrapper>
        <div>
          <img src={email_verification} alt="" />
          <h2>Thank you for verifying your email!</h2>
          <Link to={"/login"}>
            <button>Login</button>
          </Link>
        </div>
        <p>
          If you are not automatically redirected please click the login button
          above.
        </p>
      </Wrapper>
    </>
  );
};

export default NewEmailVerification;
